export default {
      id: "icon-register-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "icons.svg#icon-register",
      toString: function () {
        return this.url;
      }
    }